import React from "react";
import locale from "@bonliva-crm/locale";
import { FormTab } from "@components/forms/common/FormTab";
import FormSection from "@components/forms/common/FormSection";

import { ContactTypeInfo } from "../sections/ContactTypeInfo";
import { EmployeeNumberInfo } from "../sections/EmployeeNumberInfo";

export function EconomicsTab() {
  return (
    <FormTab horizontal>
      <FormSection fitted>
        <FormSection title={locale["Employment type"]} fullWidth>
          <ContactTypeInfo />
        </FormSection>
      </FormSection>

      <FormSection fitted>
        <FormSection title={locale.EmployeeNumber} fullWidth>
          <EmployeeNumberInfo />
        </FormSection>
      </FormSection>
    </FormTab>
  );
}
